import { ChangeDetectorRef, Component, Inject, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { NotificationModel, StatusModel } from '@evorait/pace-core';
import { faBan, faCircle, faExclamationTriangle, faStopCircle } from '@fortawesome/free-solid-svg-icons';
import { TranslateService } from '@ngx-translate/core';
import { StatusBadgeService } from '../../../core/services/status-badge/status-badge.service';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';

@Component({
    selector: 'pace-notification-status-badge',
    templateUrl: './notification-status-badge.component.html',
    styleUrls: ['./notification-status-badge.component.scss'],
    standalone: false,
})
export class NotificationStatusBadgeComponent implements OnInit, OnChanges {
    @Input() public notification: NotificationModel;
    @Input() public notificationStatus: StatusModel;
    @Input() public showEscalatedIcon = true;
    @Input() public showCancelledIcon = true;
    @Input() public showUnreadIcon = true;

    public faExclamationTriangle = faExclamationTriangle;
    public faBan = faBan;
    public faCircle = faCircle;
    public faStopCircle = faStopCircle;
    public statusText = '';
    public statusClass = '';
    public showBadge = true;

    public constructor(
        private readonly translate: TranslateService,
        private readonly statusBadgeService: StatusBadgeService,
        private readonly cdr: ChangeDetectorRef,
        @Inject(LogInstanceToken) private readonly log: LogInterface,
    ) {}

    public ngOnInit(): void {
        this.updateBadge();
    }

    public ngOnChanges(changesObj: SimpleChanges): void {
        if (changesObj.notificationStatus && changesObj.notificationStatus.currentValue) {
            this.updateBadge();
        }
    }

    private updateBadge(): void {
        this.statusBadgeService
            .getBadgeStatusAsync(this.notification)
            .then((badgeStatus) => {
                // badgeStatus is undefined for notifications in CRM status
                if (!badgeStatus) {
                    return;
                }

                this.statusText = this.translate.instant('NOTIFICATION_STATUS_BADGE_' + badgeStatus.badge + '_LABEL');
                this.statusClass = badgeStatus.badge.toLowerCase();

                /**
                 * The reason for this is due to a bug detected on Chromium based browsers
                 * Computed css values would not match that on the style's tab when
                 * using the browser inspector.
                 * usage of setTimeout was a solution but worked randomly
                 * See discussion in slack here (Friday Oct 24 2025)
                 * https://evorait.slack.com/archives/C074W3622/p1761317254261639
                 */
                this.showBadge = false;
                this.cdr.detectChanges();
                this.showBadge = true;
                this.cdr.detectChanges();
            })
            .catch((error) => {
                this.log.error(this.constructor.name, 'failed to get badge status', error);
            });
    }
}
